import { CapoPlugin } from "/var/deploy-agents/tgi/_work/1/s/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];